import { ContainerActions, ContainerState } from './types';

export const isMobile = window.document.body.clientWidth < 768;

export const initialState: ContainerState = {};

function keepInTouchReducer(state: ContainerState = initialState, action: ContainerActions) {
  const { type } = action as any;
  switch (type) {
    default:
      return state;
  }
}

export default keepInTouchReducer;
